import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { StoreAdvancedForm } from 'domains/Store/components'
import { useStoreBaseActions } from 'domains/Store/hooks'

const StoreCreatePage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting base actions */
  const { onBack } = useStoreBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Store create'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  return (
    <PageWrapper
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        <Col cw={[12, 12, 10, 8, 7]}>
          <StoreAdvancedForm />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default StoreCreatePage
